export default {
  'Authorization': localStorage.getItem( "Authorization" ),
  'API_BASE_URI': process.env.API_ROOT,
  'URI_SUFFIX': {
    'login': '/bo/login',
    'logout': '/bo/logout',
    'transactions': '/merchant-dashboard/getAllTxnsForMarketplace',
    'updateTransaction': '/merchant-dashboard/updateTxnStatus',
    'updateTransactionWithAmount': '/merchant-dashboard/',
    'deliveryUpdate': '/deliveryupdate'
  },
  getEndpoint ( identifier, orderId = '' ) {
    let URI_SUFFIX
    switch ( identifier ) {
      case 'login':
        URI_SUFFIX = this.URI_SUFFIX.login
        break
      case 'logout':
        URI_SUFFIX = this.URI_SUFFIX.logout
        break
      case 'transactions':
        URI_SUFFIX = this.URI_SUFFIX.transactions
        break
      case 'updateTransaction':
        URI_SUFFIX = this.URI_SUFFIX.updateTransaction
        break
      case 'updateTransactionWithAmount':
        URI_SUFFIX = this.URI_SUFFIX.updateTransactionWithAmount
        break
      case 'deliveryUpdate':
        URI_SUFFIX = `/merchant-dashboard/${orderId}${this.URI_SUFFIX.deliveryUpdate}`
        break
    }
    return this.API_BASE_URI + URI_SUFFIX
  }
}



// WEBPACK FOOTER //
// ./src/config.js